import taskPriceRecompute from './taskPriceRecompute';

function actionRecalculate(idTaskPrice: string) {
    taskPriceRecompute(idTaskPrice, 1);
    taskPriceRecompute(idTaskPrice, 0);
}

export default actionRecalculate;
